/*
  Component: Pasted copy
  Responsibility: take the typography out of editor-written copy, so the theme's stylesheets
                  decide it.

  Rich text is written in the Shopify editor and much of it was pasted in from somewhere else,
  which leaves inline styles behind: <span style="font-weight: 400"> on one paragraph and
  nothing on the next, a font-family from a word processor, a font-size in points. An inline
  style beats any stylesheet rule, so that text ignores the theme entirely — several weights of
  body copy that no one chose, and headings that do not answer to Theme editor → Global type
  scale because a pasted font-size outranks the tier they are supposed to read.

  It does not show on the reference storefront, and not because its content is cleaner: its body
  font registers 500, 600 and 700 against one medium file, so every weight in the copy collapses
  into the same two looks. Ours is Ubuntu with real faces at 300, 500 and 700, so the same
  content shows every difference.

  Named for the behaviour and not for the article it was first written for. Any container of
  editor-written copy opts in with data-kl-pasted-copy — today the article body and the page
  body, and the two are the same problem, not two problems that look alike.

  Three properties are removed and no others: the three the theme's own stylesheets own.
  Colour, alignment and anything else a writer set on purpose is left alone, and <strong> and
  <b> are untouched — they carry no inline style, so the bold lead-in on a list item survives
  exactly as the editor typed it.
*/

/* Prefixed: every authored script shares one global scope. */
const KL_PASTED_COPY_PROPERTIES = ['font-weight', 'font-family', 'font-size'];

function stripPastedCopyType(contentElement) {
  contentElement.querySelectorAll('[style]').forEach((styledElement) => {
    KL_PASTED_COPY_PROPERTIES.forEach((propertyName) => {
      styledElement.style.removeProperty(propertyName);
    });

    /* An element whose whole style attribute was one of those three is left without an empty
       one, so the markup reads as though it never carried it. */
    if (styledElement.getAttribute('style') === '') styledElement.removeAttribute('style');
  });
}

document.querySelectorAll('[data-kl-pasted-copy]').forEach(stripPastedCopyType);
